/* src/app/private/components/packages/delete-package/delete-package.component.scss */
/*# sourceMappingURL=delete-package.component.css.map */
